import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./Login.scss";
import { NavLink } from "react-router-dom";
import { useFormik } from "formik";
import classNames from "classnames";
import SubmitButton from "../../components/submitButton/SubmitButton";
import styled, { keyframes } from "styled-components";
import { loginAction } from "../../redux/actions/authAction";
import { useDispatch } from "react-redux";
import LogoImg from "../../Images/webviperslogo.png";

// Keyframes for animation
const fadeInZoom = keyframes`
  0% { 
    opacity: 0;
    transform: scale(0.5);
  }
  100% { 
    opacity: 1;
    transform: scale(1);
  }
`;

// Creating a Styled Component for logo
const StyledHeading = styled.h1`
  animation: ${fadeInZoom} 5s ease-in-out;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-align: center;
`;

const Logo = styled.img`
  animation: ${fadeInZoom} 5s ease-in-out;
  width: 50px;
`;

const Login = () => {
  const [loading, setloading] = useState(false);
  const [obscuredPassword, setObscuredPassword] = useState("");
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate: (data) => {
      let errors = {};

      if (!data.email) {
        errors.email = "Email is required.";
      }
      if (!data.password) {
        errors.password = "Password is required.";
      }
      return errors;
    },
    onSubmit: async (data) => {
      setloading(true);
      data.password = obscuredPassword; // set password to the value of the obscured password

      try {
        dispatch(loginAction(data));
      } catch (error) {
        // handle your error here, such as logging it or displaying an error message
        console.error(error);
      } finally {
        setloading(false);
      }
    },
  });
  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const handlePasswordInput = (e) => {
    const newPassword = e.target.value;
    const difference = newPassword.length - obscuredPassword.length;

    if (difference > 0) {
      const addedChars = newPassword.slice(-difference);
      setObscuredPassword(obscuredPassword + addedChars);
      e.target.value = "*".repeat(newPassword.length);
    } else if (difference < 0) {
      setObscuredPassword(
        obscuredPassword.slice(0, obscuredPassword.length + difference)
      );
    }
  };

  let history = useHistory();
  return (
    <div className="Login__Body">
      <div className="container_login" id="container">
        <div className="form-container sign-in-container">
          <form
            action="#"
            className="Login__Form"
            onSubmit={formik.handleSubmit}
            autoComplete="off"
          >
            <div className="p-mb-4">
              <Logo src={LogoImg} alt="WebVipers Logo" />
            </div>
            <div className="">
              <div className="p-field p-text-left">
                <label
                  htmlFor="email"
                  className={classNames({
                    "p-error": isFormFieldValid("email"),
                  })}
                >
                  Email
                </label>
                <input
                  autoComplete="off"
                  id="email"
                  className={classNames(
                    { "p-invalid": isFormFieldValid("email") },
                    "Login__Input"
                  )}
                  name="email"
                  value={formik.values.email}
                  placeholder="Enter Email"
                  onChange={formik.handleChange}
                  type="search"
                />
                {getFormErrorMessage("email")}
              </div>
              <div className="p-field p-text-left">
                <label
                  htmlFor="password"
                  className={classNames({
                    "p-error": isFormFieldValid("password"),
                  })}
                >
                  Password
                </label>
                <input
                  autoComplete="off"
                  className={classNames(
                    { "p-invalid": isFormFieldValid("password") },
                    "Login__Input"
                  )}
                  name="password"
                  placeholder="Enter Password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onInput={handlePasswordInput}
                  type="search"
                />
                {getFormErrorMessage("password")}
              </div>
              <div className="row mb-30 p-field">
                <div className="col-md-6 text-right clrRed">
                  <NavLink to="/forgetpassword" className="reset_pass">
                    Forgot Password?
                  </NavLink>
                </div>
              </div>
              <div className="p-mt-4">
                <SubmitButton
                  label="Login"
                  loading={loading}
                  className="Login__Button"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
